<i class="fas fa-info-circle info-icon" 
   (click)="openPopup()"
   [style.fontSize]="iconSize"
   [style.color]="iconColor"
   [pTooltip]="isTooltip ? message : ''"
   [tooltipPosition]="tooltipPosition"
   tooltipStyleClass="ipm-custom-tooltip"
   [escape]="false">
</i>

<ng-template #infoPopupTemplate let-data>
  <div class="ipm-info-popup-container">
    <div class="ipm-close-icon" *ngIf="!showButton" >
      <i class="pi pi-times" (click)="closeDialog()"></i>
    </div>
    <div class="ipm-heading-section">
      {{ data?.title }}
    </div>
    <div class="ipm-info-body">
      <ng-container *ngIf="data?.feeBreakdown; else plainMessage">

        <!-- myOrder fee breakdown -->
        <ng-container *ngIf="data.feeBreakdown.type === 'myOrder'">
          <div class="ipm-fee-row">
            <span>Sub Total</span>
            <span>{{ data.feeBreakdown.subTotal | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-row ipm-fee-discount" *ngIf="data.feeBreakdown.discount > 0">
            <span>Discount</span>
            <span>- {{ data.feeBreakdown.discount | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-row">
            <span>Platform Fee</span>
            <span>{{ data.feeBreakdown.platformFee | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-divider"></div>
          <div class="ipm-fee-row ipm-fee-total">
            <span>Total Paid</span>
            <span>{{ data.feeBreakdown.total | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
        </ng-container>

        <!-- studioOrder fee breakdown -->
        <ng-container *ngIf="data.feeBreakdown.type === 'studioOrder'">
          <div class="ipm-fee-row">
            <span>Revenue</span>
            <span>{{ data.feeBreakdown.revenue | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-divider"></div>
          <div class="ipm-fee-row ipm-fee-subtotal">
            <span>Platform Fee</span>
            <span>- {{ data.feeBreakdown.totalDeducted | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-sub-row">
            <span>Commission</span>
            <span>{{ data.feeBreakdown.commissionTotal | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-sub-row">
            <span>Gateway</span>
            <span>{{ data.feeBreakdown.gatewayFeeTotal | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-sub-row">
            <span>GST @ 18%</span>
            <span>{{ data.feeBreakdown.gst | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
          <div class="ipm-fee-divider"></div>
          <div class="ipm-fee-row ipm-fee-earnings">
            <span>Earnings</span>
            <span>{{ data.feeBreakdown.earnings | currency:'INR':'symbol':'1.2-2' }}</span>
          </div>
        </ng-container>

      </ng-container>
      <ng-template #plainMessage>
        <p [innerHTML]="data?.message"></p>
      </ng-template>
    </div>
    <div *ngIf="showButton" class="ipm-info-footer">
      <button  (click)="closeDialog()">Got it!</button>
    </div>
  </div>
</ng-template>
